import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { distributionLabel } from '../../utils/ruleFormat';
import { pluralRu } from '../../utils/pluralRu';
import './DistributionDonut.css';

export const DONUT_COLORS = [
  '#2563eb', '#f59e0b', '#10b981', '#ef4444',
  '#8b5cf6', '#06b6d4', '#ec4899', '#84cc16',
];

const SIZE = 160;

const formatShare = (value) => {
  const n = Number(value);
  if (value == null || !Number.isFinite(n)) return '—';
  return `${n.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};

const formatCount = (value) => {
  const n = Number(value);
  if (value == null || !Number.isFinite(n)) return '—';
  return n.toLocaleString('ru-RU');
};

const clampPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.min(100, Math.max(0, n));
};

/**
 * countKey — поле счётчика среза (violations_count у нарушений,
 * business_events_count у бизнес-событий). labelOf — подпись среза; для
 * бизнес-метрик берётся из каталога по business_metric_key (BM v2 §5).
 */
export default function DistributionDonut({
  title, distribution, unitForms, emptyText, countKey = 'violations_count', labelOf = distributionLabel,
}) {
  const total = Number(distribution?.total) || 0;
  const slices = Array.isArray(distribution?.slices) ? distribution.slices : [];

  return (
    <div className="ddonut">
      {title && <div className="ddonut-title">{title}</div>}
      {total <= 0 ? (
        <div className="ddonut-empty">{emptyText}</div>
      ) : (
        <div className="ddonut-body">
          <div className="ddonut-chart" aria-hidden="true" style={{ width: SIZE, height: SIZE }}>
            <PieChart width={SIZE} height={SIZE}>
              <Pie
                data={slices}
                dataKey={countKey}
                nameKey="category"
                innerRadius={52}
                outerRadius={76}
                paddingAngle={slices.length > 1 ? 1 : 0}
                stroke="none"
                isAnimationActive={false}
              >
                {slices.map((slice, i) => (
                  <Cell key={`${slice.category}-${i}`} fill={DONUT_COLORS[i % DONUT_COLORS.length]} />
                ))}
              </Pie>
            </PieChart>
            <div className="ddonut-center">
              <div className="ddonut-total" data-testid="donut-total">{formatCount(total)}</div>
              <div className="ddonut-unit" data-testid="donut-unit">{pluralRu(total, unitForms)}</div>
            </div>
          </div>
          <ul className="ddonut-list">
            {slices.map((slice, i) => {
              const color = DONUT_COLORS[i % DONUT_COLORS.length];
              const label = labelOf(slice);
              return (
                <li className="ddonut-row" key={`${slice.category}-${i}`}>
                  <span className="ddonut-dot" style={{ background: color }} />
                  <span className="ddonut-label" title={label}>{label}</span>
                  <span className="ddonut-bar">
                    <span
                      className="ddonut-bar-fill"
                      style={{ width: `${clampPercent(slice.share_percent)}%`, background: color }}
                    />
                  </span>
                  <span className="ddonut-count">{formatCount(slice[countKey])}</span>
                  <span className="ddonut-share">{formatShare(slice.share_percent)}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
